'use client';

import { ReactNode } from 'react';
import { Box, BoxProps, Button, Tooltip } from '@/primitives';
import Link from 'next/link';

interface Props extends BoxProps {
  label: ReactNode;
  pathname: string;
}

export default function HyperLink({ label, pathname, ...rest }: Props) {
  return (
    <Box onClick={(e) => e.stopPropagation()} {...rest}>
      <Tooltip title="View Details">
        <Link href={pathname}>
          <Button
            variant="text"
            size="small"
            sx={{
              display: 'inline',
              maxWidth: '100%',
              overflow: 'hidden',
              textAlign: 'left',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              '&:hover': { backgroundColor: 'action.hover' },
            }}
          >
            {label}
          </Button>
        </Link>
      </Tooltip>
    </Box>
  );
}
